import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgArrowRight from '../../svg/arrow-right.svg'
import { IconProps } from '../icon-props'

const ArrowRightIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgArrowRight
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-arrowright', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default ArrowRightIcon
